var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestTubereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.375L8.81253 20.0625C8.49287 20.3834 8.113 20.638 7.69471 20.8117C7.27642 20.9854 6.82795 21.0749 6.37503 21.0749C5.9221 21.0749 5.47363 20.9854 5.05534 20.8117C4.63706 20.638 4.25719 20.3834 3.93753 20.0625V20.0625C3.61665 19.7428 3.36205 19.363 3.18832 18.9447C3.0146 18.5264 2.92517 18.0779 2.92517 17.625C2.92517 17.1721 3.0146 16.7236 3.18832 16.3053C3.36205 15.887 3.61665 15.5072 3.93753 15.1875L16.125 3L21.75 8.625L19.5 9.375Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 12.7502C6.375 12.7502 8.25 11.2502 11.25 12.7502C14.25 14.2502 16.125 12.7502 16.125 12.7502",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTestTubereact;